// extracted by mini-css-extract-plugin
module.exports = {"card":"StepCard_card__6Uu2j","content":"StepCard_content__lldAq","title":"StepCard_title__C23N6","description":"StepCard_description__ds7Hz","image":"StepCard_image__BZccW"};